/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  forwardRef,
  ForwardRefRenderFunction,
  Fragment,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { format, parseISO } from 'date-fns';
import { FormHandles } from '@unform/core';
import { AxiosResponse } from 'axios';
import * as Yup from 'yup';
import Swal from 'sweetalert2';

import getValidationErros from '~/utils/getValidationsErrors';
import api from '~/services/api';

import { Container } from './styles';
import Input from '~/components/Input';
import { IBatch } from '../Batches';
import { IModalityData } from '../Modalities';
import InputMask from '~/components/InputMask';
import Loading from '~/components/Loading';
import { IBatchCategory } from '../Interfaces';

export interface IPricePlace {
  input_id: number;
  qtdPlaces?: number;
  expiration: Date;
}

interface IBatchError {
  batch_id: number;
  error: string;
}

interface IPricesPlaces {
  event_id: number;
  batches: IBatch[];
  modalities: IModalityData[];
  onChange(data: IPricePlace[], batchesCategories: IBatchCategory[]): void;
  statusName?: string;
  batchesCategories: IBatchCategory[];
  progressNumber?: number;
}

export interface IPricesPlacesHandle {
  submit: () => void;
}

const PricesPlaces: ForwardRefRenderFunction<
  IPricesPlacesHandle,
  IPricesPlaces
> = (
  {
    event_id,
    batches: initialBatches,
    modalities,
    onChange,
    statusName,
    batchesCategories: batchesCategoriesData,
    progressNumber,
  },
  ref
) => {
  const formRef = useRef<FormHandles>(null);
  const [batchesErrors, setBatchesErrors] = useState<IBatchError[]>([]);
  const [pricesPlacesError, setPricesPlacesError] = useState('');
  const [batches, setBatches] = useState<IBatch[]>([]);
  const [oldBatches, setOldBatches] = useState<IBatch[]>([]);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('Carregando...');

  // Verifica se é um ID temporário gerado com new Date().getTime()
  const isTemporaryId = (id: number): boolean => {
    return id.toString().length === 13;
  };

  // useEffect(() => {
  //   if (initialBatches && initialBatches.length > 0) {
  //     const newBatches = initialBatches.slice();
  //     let index = 0;
  //     for (const batch of newBatches) {
  //       for (const modality of modalities) {
  //         if (modality.categories) {
  //           for (const category of modality.categories) {
  //             const { batchesCategories } = batch;

  //             console.log(batchesCategories);

  //             // if (batchesCategories) {
  //             //   const batchCategoryIndex = batchesCategories.findIndex(
  //             //     (batchCategory) =>
  //             //       batchCategory.category_id === category.id &&
  //             //       batchCategory.modality_id === modality.id
  //             //   );
  //             //   // if (batchCategoryIndex === -1) {
  //             //   //   batchesCategories.push({
  //             //   //     id: new Date().getTime() * -1,
  //             //   //     event_id,
  //             //   //     batch_id: batch.input_id,
  //             //   //     category_id: category.id as number,
  //             //   //     modality_id: modality.id as number,
  //             //   //     quantity: 0,
  //             //   //     quantity_sold: 0,
  //             //   //     price: '0',
  //             //   //   });
  //             //   // }
  //             // } else {
  //             //   batchesCategories = [
  //             //     {
  //             //       id: new Date().getTime() * -1,
  //             //       event_id,
  //             //       batch_id: batch.input_id,
  //             //       category_id: category.id as number,
  //             //       modality_id: modality.id as number,
  //             //       quantity: 0,
  //             //       quantity_sold: 0,
  //             //       price: '0',
  //             //     },
  //             //   ];
  //             // }

  //             newBatches[index].batchesCategories = batchesCategories;
  //           }
  //         }
  //       }

  //       index += 1;
  //     }

  //     setBatches(newBatches);
  //     setOldBatches(JSON.parse(JSON.stringify(newBatches)));
  //   }
  // }, [event_id, initialBatches, modalities]);

  useEffect(() => {
    if (progressNumber && progressNumber === 8) {
      api.delete(`batches-categories/events/${event_id}`).catch((err) => {
        console.log(err);
      });
    }
  }, [event_id, progressNumber]);

  useEffect(() => {
    if (initialBatches && initialBatches.length > 0) {
      const newBatches = initialBatches.slice();
      const promises = initialBatches.map((batch) =>
        api.get(`batches-categories/batches/${batch.input_id}`)
      );

      Promise.all(promises).then((responses) => {
        responses.forEach((response, index) => {
          newBatches[index].batchesCategories = response.data;
        });
        setBatches(newBatches);
        setOldBatches(JSON.parse(JSON.stringify(newBatches)));
      });
    }
  }, [initialBatches]);

  const handleChangeQuantity = useCallback(
    (e, category, batchIndex, modalityId) => {
      const newBatches = batches.slice();

      let total = newBatches[batchIndex].batchesCategories?.reduce(
        (previous, current) => {
          if (current.modality_id !== modalityId) {
            return previous + parseInt(current.quantity.toString(), 10);
          }
          if (
            current.category_id !== category.id &&
            current.modality_id === modalityId
          ) {
            return previous + parseInt(current.quantity.toString(), 10);
          }

          return previous;
        },
        0
      );
      total = (total || 0) + parseInt(e.target.value || '0', 10);

      setBatchesErrors((oldState) =>
        oldState.filter(
          (error) => error.batch_id !== newBatches[batchIndex].input_id
        )
      );

      newBatches[batchIndex] = {
        ...newBatches[batchIndex],
        restPlaces: (newBatches[batchIndex].qtdPlaces || 0) - total,
      };

      let batchCategoryIndex = newBatches[
        batchIndex
      ].batchesCategories?.findIndex(
        (batchCategory) =>
          batchCategory.category_id === category.id &&
          batchCategory.modality_id === modalityId
      );

      if (
        typeof batchCategoryIndex !== 'undefined' &&
        batchCategoryIndex >= 0
      ) {
        const { batchesCategories } = newBatches[batchIndex];
        if (batchesCategories) {
          batchesCategories[batchCategoryIndex].quantity = parseInt(
            e.target.value,
            10
          );
          newBatches[batchIndex].batchesCategories = batchesCategories;
        }
      } else {
        const { batchesCategories } = newBatches[batchIndex];
        if (batchesCategories) {
          batchesCategories.push({
            id: new Date().getTime() * -1,
            event_id,
            batch_id: newBatches[batchIndex].input_id,
            category_id: category.id,
            modality_id: modalityId,
            quantity: parseInt(e.target.value, 10),
            quantity_sold: 0,
            price: '0',
          });
          newBatches[batchIndex].batchesCategories = batchesCategories;
          batchCategoryIndex =
            newBatches[batchIndex].batchesCategories?.length || 0;
        } else {
          newBatches[batchIndex].batchesCategories = [
            {
              id: new Date().getTime() * -1,
              event_id,
              batch_id: newBatches[batchIndex].input_id,
              category_id: category.id,
              modality_id: modalityId,
              quantity: parseInt(e.target.value, 10),
              quantity_sold: 0,
              price: '0',
            },
          ];
          batchCategoryIndex = 0;
        }
      }

      setBatches(newBatches);
    },
    [batches, event_id]
  );

  const handleChangePrice = useCallback(
    (e, category, batchIndex, modalityId) => {
      const newBatches = batches.slice();

      const batchCategoryIndex = newBatches[
        batchIndex
      ].batchesCategories?.findIndex((batchCategory) => {
        return (
          batchCategory.category_id === category.id &&
          batchCategory.modality_id === modalityId
        );
      });

      if (
        typeof batchCategoryIndex !== 'undefined' &&
        batchCategoryIndex >= 0
      ) {
        const { batchesCategories } = newBatches[batchIndex];
        if (batchesCategories) {
          batchesCategories[batchCategoryIndex].price = parseFloat(
            e.target.value
              .replace('R$', '')
              .replaceAll('.', '')
              .replace(',', '.')
          ).toFixed(2);
          newBatches[batchIndex].batchesCategories = batchesCategories;
        }
      } else {
        const { batchesCategories } = newBatches[batchIndex];
        if (batchesCategories) {
          batchesCategories.push({
            id: new Date().getTime() * -1,
            event_id,
            batch_id: newBatches[batchIndex].input_id,
            category_id: category.id,
            modality_id: modalityId,
            quantity: 0,
            quantity_sold: 0,
            price: parseFloat(
              e.target.value
                .replace('R$', '')
                .replaceAll('.', '')
                .replace(',', '.')
            ).toFixed(2),
          });
          newBatches[batchIndex].batchesCategories = batchesCategories;
        } else {
          newBatches[batchIndex].batchesCategories = [
            {
              id: new Date().getTime() * -1,
              event_id,
              batch_id: newBatches[batchIndex].input_id,
              category_id: category.id,
              modality_id: modalityId,
              quantity: 0,
              quantity_sold: 0,
              price: parseFloat(
                e.target.value
                  .replace('R$', '')
                  .replaceAll('.', '')
                  .replace(',', '.')
              ).toFixed(2),
            },
          ];
        }
      }

      setBatches(newBatches);
    },
    [batches, event_id]
  );

  const handleSubmit = useCallback(
    async (data) => {
      if (loading) return;
      try {
        setLoading(true);
        setLoadingText('Salvando...');
        formRef.current?.setErrors({});
        setPricesPlacesError('');

        const schema = Yup.object().shape({
          pricesPlaces: Yup.string().test(
            'validQuantity',
            `Valor não pode ser menor que a quantidade já vendida`,
            () => {
              return batches.every((batch) => {
                return batch.batchesCategories?.every((batchCategory) => {
                  return batchCategory.quantity_sold && batchCategory.quantity
                    ? batchCategory.quantity_sold <= batchCategory.quantity
                    : true;
                });
              });
            }
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const newBatches = JSON.parse(JSON.stringify(batches));
        const newBatchesCategoriesData = JSON.parse(
          JSON.stringify(batchesCategoriesData)
        ) as IBatchCategory[];

        // Remove batch-categories órfãs (de modalidades/categorias deletadas)
        const validCombinations = modalities.flatMap((modality) =>
          (modality.categories || []).map((category) => ({
            modality_id: modality.id,
            category_id: category.id,
          }))
        );

        const filteredBatchesCategoriesData = newBatchesCategoriesData.filter(
          (bc) =>
            validCombinations.some(
              (combo) =>
                combo.modality_id === bc.modality_id &&
                combo.category_id === bc.category_id
            )
        );

        if (batches.length > 0) {
          let batchIndex = 0;
          for (const batch of batches) {
            if (batch.batchesCategories) {
              const { batchesCategories } = batch;

              const oldBatch = oldBatches[batchIndex];
              newBatches[batchIndex].expiration = parseISO(
                newBatches[batchIndex].expiration
              );

              if (batchesCategories.length > 0) {
                let batchCategoryIndex = 0;
                for (const batchCategory of batchesCategories) {
                  const batchCategoryFormData = {
                    batch_id: batch.input_id,
                    category_id: batchCategory.category_id,
                    modality_id: batchCategory.modality_id,
                    event_id,
                    quantity: batchCategory.quantity,
                    price: batchCategory.price || 0,
                    on: batchCategory.on,
                  };

                  const isOldBatchCategory = oldBatch?.batchesCategories?.some(
                    (oldBatchCategory) =>
                      oldBatchCategory.id &&
                      oldBatchCategory.id === batchCategory.id &&
                      oldBatchCategory.id > 0 &&
                      !isTemporaryId(oldBatchCategory.id)
                  );

                  let responseBatchCategory: AxiosResponse;

                  if (isOldBatchCategory) {
                    responseBatchCategory = await api.put(
                      `batches-categories/${batchCategory.id}`,
                      batchCategoryFormData
                    );

                    const batchCategoryDataIndex =
                      filteredBatchesCategoriesData.findIndex(
                        (batchCategoryData) => {
                          return batchCategoryData.id === batchCategory.id;
                        }
                      );
                    filteredBatchesCategoriesData[
                      batchCategoryDataIndex
                    ].batch_id = responseBatchCategory.data.batch_id;
                    filteredBatchesCategoriesData[
                      batchCategoryDataIndex
                    ].quantity = responseBatchCategory.data.quantity;
                    filteredBatchesCategoriesData[
                      batchCategoryDataIndex
                    ].price = responseBatchCategory.data.price;
                    filteredBatchesCategoriesData[batchCategoryDataIndex].on =
                      responseBatchCategory.data.on;
                  } else {
                    let emptyBatchCategory: IBatchCategory | undefined;
                    const modality = modalities.find(
                      (modalityData) =>
                        modalityData.id === batchCategory.modality_id
                    );

                    if (modality) {
                      const category = modality.categories?.find(
                        (categoryData) =>
                          categoryData.id === batchCategory.category_id
                      );

                      if (category) {
                        emptyBatchCategory = filteredBatchesCategoriesData.find(
                          (batchCategoryData) =>
                            batchCategoryData.new &&
                            !isTemporaryId(batchCategoryData.id)
                        );
                      }
                    }

                    if (emptyBatchCategory) {
                      responseBatchCategory = await api.put(
                        `batches-categories/${emptyBatchCategory.id}`,
                        batchCategoryFormData
                      );
                      const batchCategoryDataIndex =
                        filteredBatchesCategoriesData.findIndex(
                          (batchCategoryData) =>
                            batchCategoryData.id === emptyBatchCategory?.id
                        );
                      filteredBatchesCategoriesData[
                        batchCategoryDataIndex
                      ].batch_id = responseBatchCategory.data.batch_id;
                      filteredBatchesCategoriesData[
                        batchCategoryDataIndex
                      ].quantity = responseBatchCategory.data.quantity;
                      filteredBatchesCategoriesData[
                        batchCategoryDataIndex
                      ].price = responseBatchCategory.data.price;
                      filteredBatchesCategoriesData[batchCategoryDataIndex].on =
                        responseBatchCategory.data.on;
                      filteredBatchesCategoriesData[
                        batchCategoryDataIndex
                      ].new = false;
                    } else {
                      responseBatchCategory = await api.post(
                        `batches-categories`,
                        batchCategoryFormData
                      );
                      filteredBatchesCategoriesData.push({
                        id: responseBatchCategory.data.id,
                        batch_id: responseBatchCategory.data.batch_id,
                        category_id: responseBatchCategory.data.category_id,
                        modality_id: responseBatchCategory.data.modality_id,
                        event_id: responseBatchCategory.data.event_id,
                        quantity: responseBatchCategory.data.quantity,
                        price: responseBatchCategory.data.price,
                        quantity_sold: responseBatchCategory.data.quantity_sold,
                        on: responseBatchCategory.data.on,
                      });
                    }
                  }

                  newBatches[batchIndex].batchesCategories[
                    batchCategoryIndex
                  ].id = responseBatchCategory.data.id;
                  batchCategoryIndex += 1;
                }
              }

              // if (
              //   deletedBatchesCategories &&
              //   deletedBatchesCategories.length > 0
              // ) {
              //   for (const deletedBatchCategory of deletedBatchesCategories) {
              //     await api.delete(
              //       `batches-categories/${deletedBatchCategory.id}`
              //     );
              //   }
              // }
            }

            batchIndex += 1;
          }
        }

        setBatches(newBatches);
        setOldBatches(JSON.parse(JSON.stringify(newBatches)));
        onChange(newBatches, filteredBatchesCategoriesData);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
          if (errors.pricesPlaces) {
            setPricesPlacesError(errors.pricesPlaces);
          }
        } else {
          console.log(error);
          Swal.fire('Oops...', 'Erro ao salvar os lotes!');
        }
      } finally {
        setLoading(false);
        setLoadingText('Carregando...');
      }
    },
    [
      batches,
      batchesCategoriesData,
      event_id,
      loading,
      modalities,
      oldBatches,
      onChange,
    ]
  );

  useImperativeHandle(
    ref,
    () => ({
      submit: () => {
        formRef.current?.submitForm();
      },
    }),
    []
  );

  const handleSuspendBatch = useCallback(
    (category, batchIndex, modalityId) => {
      const newBatches = batches.slice();

      const batchCategoryIndex = newBatches[
        batchIndex
      ].batchesCategories?.findIndex(
        (batchCategory) =>
          batchCategory.category_id === category.id &&
          batchCategory.modality_id === modalityId
      );

      if (
        typeof batchCategoryIndex !== 'undefined' &&
        batchCategoryIndex >= 0
      ) {
        const { batchesCategories } = newBatches[batchIndex];
        if (batchesCategories) {
          batchesCategories[batchCategoryIndex].on =
            !batchesCategories[batchCategoryIndex].on;
          newBatches[batchIndex].batchesCategories = batchesCategories;
        }
      } else {
        const { batchesCategories } = newBatches[batchIndex];
        if (batchesCategories) {
          batchesCategories.push({
            id: new Date().getTime() * -1,
            event_id,
            batch_id: newBatches[batchIndex].input_id,
            category_id: category.id,
            modality_id: modalityId,
            quantity: 0,
            quantity_sold: 0,
            price: '0',
            on: true,
          });
          newBatches[batchIndex].batchesCategories = batchesCategories;
        } else {
          newBatches[batchIndex].batchesCategories = [
            {
              id: new Date().getTime() * -1,
              event_id,
              batch_id: newBatches[batchIndex].input_id,
              category_id: category.id,
              modality_id: modalityId,
              quantity: 0,
              quantity_sold: 0,
              price: '0',
              on: false,
            },
          ];
        }
      }

      setBatches(newBatches);
    },
    [batches, event_id]
  );

  return (
    <Container ref={formRef} onSubmit={handleSubmit} className="row">
      <div className="col-12">
        <h2 className="h4 fw-semibold text-center mt-5 mb-5">
          8 - Preços e vagas
        </h2>
      </div>
      {batches.map((batch, index) => (
        <div key={batch.input_id} className="col-lg-6">
          <div className="bg-category p-3 mb-3">
            <h5 className="roboto h5 fw-semibold">Lote {index + 1}</h5>
            <p className="mb-0">
              Vagas:{' '}
              {batch.qtdPlaces?.toString() === '0' || !batch.qtdPlaces
                ? 'Ilimitadas'
                : batch.qtdPlaces}{' '}
              | Validade: {format(batch.expiration, 'dd/MM/yyyy')} | Qtd.
              vendida: {batch.qtdSold || 0}
            </p>
          </div>
          {modalities.map((modality) => (
            <Fragment key={modality.id}>
              {modality.categories?.map((category) => (
                <div
                  key={category.id}
                  className="all-lots bd-lots mb-3 p-3 d-flex justify-content-between align-items-center"
                >
                  <h3 className="h6 mb-0 fw-semibold roboto align-items-center">
                    {modality.name}: {category.name}
                    <br />
                    <small>
                      Qtd. vendida:{' '}
                      {batch.batchesCategories?.find(
                        (batchCategory) =>
                          batchCategory.category_id === category.id &&
                          batchCategory.modality_id === modality.id
                      )?.quantity_sold || 0}
                    </small>
                  </h3>
                  <div className="qty-size">
                    <span className="w-75 mx-auto roboto h6 fw-normal mb-2 d-block">
                      Qtd. de vagas
                    </span>
                    <Input
                      type="number"
                      disabled={statusName !== 'Rascunho' && batch.expired}
                      name="qtd-places"
                      onChange={(e) =>
                        handleChangeQuantity(e, category, index, modality.id)
                      }
                      className={`${
                        !!batchesErrors.find(
                          (batchError) => batchError.batch_id === batch.input_id
                        )?.error && 'border-danger'
                      } w-75 mx-auto input`}
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      defaultValue={
                        batch.batchesCategories?.find(
                          (batchCategory) =>
                            batchCategory.category_id === category.id &&
                            batchCategory.modality_id === modality.id
                        )?.quantity
                      }
                    />
                    <small className="d-block text-center text-danger">
                      {
                        batchesErrors.find(
                          (batchError) => batchError.batch_id === batch.input_id
                        )?.error
                      }
                    </small>
                  </div>
                  <div
                    className={
                      statusName !== 'Rascunho' &&
                      (batch.expired || batch.initialized)
                        ? 'pe-none'
                        : ''
                    }
                  >
                    <span className="w-75 mx-auto roboto h6 fw-normal mb-2 d-block">
                      Preços
                    </span>
                    <InputMask
                      kind="money"
                      name="price"
                      placeholder="R$ 0,00"
                      onChange={(e) =>
                        handleChangePrice(e, category, index, modality.id)
                      }
                      className="w-75 mx-auto input"
                      value={
                        batch.batchesCategories?.find(
                          (batchCategory) =>
                            batchCategory.category_id === category.id &&
                            batchCategory.modality_id === modality.id
                        )?.price
                      }
                    />
                  </div>
                  <div>
                    <span className="w-75 mx-auto roboto h6 fw-normal mb-2 d-block text-center">
                      Suspender
                    </span>
                    <div className="form-check form-switch d-flex justify-content-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        disabled={statusName !== 'Rascunho' && batch.expired}
                        id="flexSwitchCheckDefault"
                        onChange={() =>
                          handleSuspendBatch(category, index, modality.id)
                        }
                        checked={
                          typeof batch.batchesCategories?.find(
                            (batchCategory) =>
                              batchCategory.category_id === category.id &&
                              batchCategory.modality_id === modality.id
                          )?.on === 'undefined'
                            ? false
                            : !batch.batchesCategories?.find(
                                (batchCategory) =>
                                  batchCategory.category_id === category.id &&
                                  batchCategory.modality_id === modality.id
                              )?.on
                        }
                      />
                    </div>
                  </div>
                </div>
              ))}
            </Fragment>
          ))}
        </div>
      ))}
      {pricesPlacesError && (
        <span className="small text-danger error">{pricesPlacesError}</span>
      )}
      <Loading active={loading} text={loadingText} />
    </Container>
  );
};

export default forwardRef(PricesPlaces);
